/* eslint-disable no-param-reassign */
const filterChildren = (children, parentComponent) => {
  const withGTMChildren = [];
  const nonGTMChildren = [];
  children.forEach(child => {
    const { props: { component: { type = '' } = {} } = {} } = child;
    type === 'gtm-events'
      ? withGTMChildren.push({ ...child, props: { ...child.props, parentComponent } })
      : nonGTMChildren.push(child);
  });
  return { withGTMChildren, nonGTMChildren };
};

const buildListChildren = (children, filteredChildren, data) => {
  const { props: childProps, props: { children: nestedChildren } = {} } = children;
  const childrenWithData = data
    ? filteredChildren.map(child => {
        child.props.component.settings.parentData = data;
        return child;
      })
    : filteredChildren;

  return childrenWithData && childrenWithData.length
    ? {
        ...children,
        props: {
          ...childProps,
          children: [nestedChildren[0], childrenWithData]
        }
      }
    : null;
};

const splitChildren = (children, parentData, graphqlEntityMap, parentComponent = {}) => {
  if (!children || Array.isArray(children)) return { regularChildren: children };
  const { props: { children: nestedChildren } = {} } = children;

  const { nonGTMChildren, withGTMChildren } = filterChildren(nestedChildren[1], parentComponent);
  const regularChildren = buildListChildren(children, nonGTMChildren);
  const parentDataWithEntity = parentData.map(item => ({
    ...item,
    itemId: item.id,
    itemEntity: graphqlEntityMap[item.__typename]
  }));

  const gtmChildren = buildListChildren(children, withGTMChildren, parentDataWithEntity);

  return { regularChildren, gtmChildren };
};

export default splitChildren;
